import { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { DataContext } from "../../../utils/DataContext";
import { useTranslation } from "react-i18next";
import useLanguage from "../../../utils/useLanguage";
import { useNavigate, useParams } from "react-router-dom";
import AddShippedContainerModal from "../AddShippedContainerModal";
import ShippedContainerCard from "../../../components/ShippedContainerCard";
import BackToDashboard from "../../../components/BackToDashboard";
import Loader from "../../../components/Loader";
import SectionDivider from "../../../components/SectionDivider";
import CustomButton from "../../../components/CustomButton";
import previousIcon from "../../../assets/previous_icon.png";
import nextIcon from "../../../assets/next_icon.png";
import printIcon from "../../../assets/printer_icon.png";
import archiveIcon from "../../../assets/archive_icon.png";
import editIcon from "../../../assets/edit_icon.png";
import classes from "../../../components/Modal.module.css";
import saveIcon from "../../../assets/save_icon.png";
import closeIcon from "../../../assets/close_icon.png";
import PDFUploader from "../../../components/PDFUploader";
import MultiContainersInvoiceDetailsComponent from "./MultiContainersInvoiceDetailsComponent";
import EditInvoiceOfMultiComponent from "./EditInvoiceOfMultiComponent";
import useRandomIcon from "../../../utils/useRandomIcon";
import ErrorMessage from "../../../components/ErrorMessage";
import Modal from "../../../components/Modal";
import AreYouSureModal from "../../../components/AreYouSureModal";
import TextDiv from "../../../components/TextDiv";
import InformationBox from "../../../components/InformationBox";
import PageWrapper from "../../../components/PageWrapper";

const ViewMultiContainerInvoice = ({}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("general");
  const { id } = useParams();
  const { currentDirection } = useLanguage();
  const pdfUploaderRef = useRef(null);

  const { error, setError } = useContext(DataContext);
  const getRandomIcon = useRandomIcon();

  const [showAddShippedContainerModal, setShowAddShippedContainerModal] =
    useState(false);

  const [editMode, setEditMode] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [showAreYouSure, setShowAreYouSure] = useState(false);

  // const [newRecord, setNewRecord] = useState({});
  const [invoiceDocs, setInvoiceDocs] = useState([]);
  const [tempDocs, setTempDocs] = useState([]);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState();
  const [invoice, setInvoice] = useState({
    invoiceNumber: "",
    amountForSupplier: "",
    abstractAmountForCustomer: "",
    finalAmountForCustomer: "",
    date: new Date(),
    received: "",
    left: "",
    notes: "",
    ShippedContainer: [],
  });

  // For Edit (Show are you sure modal)
  const [tempInvoice, setTempInvoice] = useState({
    invoiceNumber: "",
    amountForSupplier: "",
    abstractAmountForCustomer: "",
    finalAmountForCustomer: "",
    date: new Date(),
    received: "",
    left: "",
    notes: "",
    ShippedContainer: [],
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_URL}/getMultiContainersInvoice/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        setLoading(false);
      }

      setInvoice(response?.data?.invoice);
      setTempInvoice({
        ...response?.data?.invoice,
        ShippedContainer: response?.data?.invoice?.ShippedContainer.map(
          (container) => {
            return {
              ...container,
              oldContainerNumber: container.containerNumber,
            };
          }
        ),
      });
      // setNewRecord(response?.data?.invoice);
      setInvoiceDocs(response?.data?.invoice?.documents);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleEdit = () => {
    setEditMode(true);
    setError("");
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setError("");
    setTempDocs([]);
    setShowAreYouSure(false);
  };

  const handleAttemptCancel = () => {
    const jsonInvoice = JSON.stringify(invoice);
    const jsonTempInvoice = JSON.stringify(tempInvoice);

    const jsonInvoiceDocs = JSON.stringify(invoice?.documents);
    const jsonInvoiceTempDocs = JSON.stringify([...invoiceDocs, ...tempDocs]);

    if (
      jsonInvoice === jsonTempInvoice &&
      jsonInvoiceDocs === jsonInvoiceTempDocs
    ) {
      handleCancelEdit();
    } else {
      setShowAreYouSure(true);
    }
  };

  const handleChildUploadDocs = (multiContainersInvoiceId) => {
    if (pdfUploaderRef.current) {
      pdfUploaderRef.current.handleUploadDocs(multiContainersInvoiceId);
    }
  };

  const handleConfirmEdit = async () => {
    const token = localStorage.getItem("token");
    const userId = parseInt(localStorage.getItem("userId"), 10);
    const organizationId = parseInt(localStorage.getItem("organizationId"), 10);
    try {
      setLoadingModal(true);
      // Send a PUT request to the backend to update the invoice with the existing data
      const editedInvoice = await axios.put(
        `${process.env.REACT_APP_URL}/updateInvoiceOfMultiConts/${invoice?.id}`,
        {
          ...tempInvoice,
          organizationId,
        },
        // { ...invoice, ...inputs }, // Send the updated record data
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "User-Id": userId,
            "Supplier-Id": invoice?.supplierId,
            // "Organization-Id": organizationId,
          },
        }
      );

      const { status, error } = editedInvoice;
      // Log the edited invoice data returned by the backend

      // Update the invoice data with the returned changes from the backend
      if (editedInvoice?.status === 200) {
        setInvoice((prev) => {
          return { ...prev, ...editedInvoice?.data?.invoice };
        });
        setError("");
      }

      // Update the new record with the backend's returned data
      // setNewRecord((prevRow) => {
      //   const { received } = newRecord;
      //   const amount = parseFloat(newRecord.amount) || 0;
      //   const receivedValue = parseFloat(received) || 0;
      //   const leftValue = (amount - receivedValue).toFixed(2).toString();

      //   return { ...editedInvoice.data, received, left: leftValue };
      // });
      setLoadingModal(false);

      handleChildUploadDocs(editedInvoice?.data?.invoice?.id);
      setEditMode(false);
    } catch (error) {
      setLoadingModal(false);
      // setError(errorMsg || "Error updating invoice.");
      const errMsg = error.response?.data?.message;
      if (errMsg === "alreadyLinkedToAnInvoice") {
        const containerNumber = error?.response?.data?.containerNumber;
        setError(`${t("container")} ${containerNumber} ${t(errMsg)}`);
      } else {
        setError(errMsg || "An error occurred");
      }

      // Log and display any errors that occur during the update process
      console.error("Error updating invoice:", error);
    } finally {
      window.scrollTo(0, 0);
    }
  };

  const handleArchive = async () => {
    const token = localStorage.getItem("token");
    const userId = parseInt(localStorage.getItem("userId"), 10);

    try {
      setLoadingModal(true);
      const archivedInvoice = await axios.delete(
        `${process.env.REACT_APP_URL}/archiveInvoiceOfMultiContainers/${invoice?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!archivedInvoice?.data) {
        console.error(`archivedInvoice.error`, archivedInvoice.error);
      }

      navigate(`/invoicesOfShippedContainers`);
    } catch (error) {
      console.error("Error updating invoice:", error);
      setError("Error updating invoice.");
    } finally {
      setLoadingModal(false);
    }
    // finally {
    //   fetchInvoices(selectedSupplier?.id);
    // }
  };

  const handleCloseArchiveModal = () => setShowArchiveModal(false);

  return (
    <>
      <PageWrapper className="add-shipped-container-page">
        {!editMode ? (
          <div className="add-shipped-container-top-actions">
            <div className="user-logout">
              <BackToDashboard
                title={t("back")}
                variant="blank"
                icon={currentDirection === "ltr" ? previousIcon : nextIcon}
                iconSize={14}
              />
            </div>
          </div>
        ) : null}
        {loading ? (
          <Loader />
        ) : (
          <>
            <h3 className={"add-shipped-container-title"}>
              {t("invoiceDetails")}
            </h3>
            {/* {error && !loadingModal && <ErrorBox>{error}</ErrorBox>} */}
            <div className={` add-shipped-container-invoice-part`}>
              <TextDiv
                title="supplier"
                value={invoice?.supplier?.name}
                divClasses="item-invoice-div"
                spanClasses="u-flex_flex-2 t-bold_bold"
                pClasses="t-bold_normal u-width-specific_150"
              />

              <TextDiv
                title="company"
                value={invoice?.subCompany?.nameInAr}
                divClasses="item-invoice-div"
                spanClasses="u-flex_flex-2 t-bold_bold"
                pClasses="t-bold_normal u-width-specific_150"
              />

              <TextDiv
                title="createdBy"
                value={invoice?.user?.username}
                divClasses="item-invoice-div"
                spanClasses="u-flex_flex-2 t-bold_bold"
                pClasses="t-bold_normal u-width-specific_150"
              />
              {/* <div className="add-shipped-container-header">
                <section className="add-shipped-container-header-section">
                  <span>{t("supplier")}: </span>
                  <span className={classes.colTitle}>
                    {invoice?.supplier?.name}
                  </span>
                </section>
                <section className="add-shipped-container-header-section">
                  <span>{t("customer")}: </span>
                  <span>
                    <span className={classes.colTitle}>
                      {invoice?.customer?.name}
                    </span>
                  </span>
                </section>
              </div>
              <div className="o-row o-row--gap-size_300 u-margin--top_400">
                <span>{t("subCompany")}:</span>
                <span className="t-bold_bold">
                  {invoice?.subCompany?.nameInAr}
                </span>
              </div> */}

              {editMode ? (
                <EditInvoiceOfMultiComponent
                  invoice={tempInvoice}
                  setInvoice={setTempInvoice}
                />
              ) : (
                <>
                  <MultiContainersInvoiceDetailsComponent invoice={invoice} />

                  <SectionDivider title={"bankApplicationInfo"} />

                  <section>
                    {invoice?.bank ? (
                      <div>
                        <TextDiv
                          title="bankAppCreator"
                          value={invoice?.bankAppCreator}
                          divClasses="item-invoice-div"
                          spanClasses="u-flex_flex-2 t-bold_bold"
                          pClasses="t-bold_normal u-width-specific_150"
                        />
                        <TextDiv
                          title="bankName"
                          value={invoice?.bank?.name}
                          divClasses="item-invoice-div"
                          spanClasses="u-flex_flex-2 t-bold_bold"
                          pClasses="t-bold_normal u-width-specific_150"
                        />
                      </div>
                    ) : (
                      <InformationBox>{t("noBankApps")}</InformationBox>
                    )}
                  </section>

                  {/* Containers */}
                  {invoice?.ShippedContainer?.length ? (
                    <SectionDivider title="containers" />
                  ) : null}
                  <div className="all-containers u-styled-scrollbar u-margin--bottom_700">
                    {invoice?.ShippedContainer?.map((item, i) => (
                      <ShippedContainerCard
                        key={i}
                        index={i}
                        src={getRandomIcon()}
                        containersLength={invoice?.ShippedContainer?.length}
                        currentDirection={currentDirection}
                        containerInfo={item}
                        subCompanyInfo={invoice?.subCompany}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <>
              {invoice?.documents?.length ? (
                <SectionDivider title="invoiceAllDocs" />
              ) : null}

              <PDFUploader
                ref={pdfUploaderRef}
                invoiceNumber={invoice?.invoiceNumber}
                invoiceDocs={invoiceDocs}
                setInvoiceDocs={setInvoiceDocs}
                mode={!editMode && "show"}
                documents={invoiceDocs}
                tempDocs={tempDocs}
                setTempDocs={setTempDocs}
                invoiceType="multiContainersInvoice"
                title="noTitle"
              />
            </>
            <div className="o-column o-column--vertical-align_end">
              <ErrorMessage>{t(error)}</ErrorMessage>
              <section className={classes.actions}>
                {editMode ? (
                  <div className="o-column">
                    {loadingModal ? <Loader /> : null}
                    <div className={classes.actions}>
                      <CustomButton
                        title={t("confirm")}
                        onClick={handleConfirmEdit}
                        icon={saveIcon}
                        iconSize={16}
                        disabled={loadingModal}
                      />
                      <CustomButton
                        title={t("cancel")}
                        onClick={handleAttemptCancel}
                        variant="blank"
                        icon={closeIcon}
                        iconSize={14}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <CustomButton
                      variant="blank"
                      title={t("edit")}
                      onClick={handleEdit}
                      icon={editIcon}
                      iconSize={18}
                    />
                    {setEditMode ? (
                      <>
                        <CustomButton
                          title={t("print")}
                          onClick={handlePrint}
                          variant="gray"
                          icon={printIcon}
                          iconSize={18}
                        />
                        {!invoice?.archived && (
                          <CustomButton
                            title={t("archive")}
                            variant="red"
                            icon={archiveIcon}
                            iconSize={20}
                            onClick={() => setShowArchiveModal(true)}
                          />
                        )}
                      </>
                    ) : null}
                  </>
                )}
              </section>
            </div>
          </>
        )}
      </PageWrapper>
      {/* Render Modal */}

      {showAddShippedContainerModal && (
        <AddShippedContainerModal
          inputs={inputs}
          setInputs={setInputs}
          onClose={() => setShowAddShippedContainerModal(false)}
          setShowAddShippedContainerModal={() =>
            setShowAddShippedContainerModal(false)
          }
        />
      )}

      {showArchiveModal && (
        <Modal
          title={t("archiveInvoice")}
          onClose={handleCloseArchiveModal}
          footer={
            <>
              {loadingModal ? <Loader /> : null}
              <section className={classes.actions}>
                <CustomButton
                  onClick={handleArchive}
                  title={t("confirm")}
                  icon={saveIcon}
                  iconSize={16}
                  disabled={loadingModal}
                />
                <CustomButton
                  title={t("cancel")}
                  onClick={handleCloseArchiveModal}
                  variant="blank"
                  icon={closeIcon}
                  iconSize={14}
                />
              </section>
            </>
          }
        >
          <div className={classes.archiveModalBody}>
            <h3 className={classes.archiveModalBodyTitle}>{t("areYouSure")}</h3>
            <p className={classes.archiveModalInvoiceNumber}>
              {invoice?.invoiceNumber}
            </p>
          </div>
        </Modal>
      )}

      {showAreYouSure ? (
        <AreYouSureModal
          onClose={() => setShowAreYouSure(false)}
          onConfirm={handleCancelEdit}
        />
      ) : null}
    </>
  );
};
// handleClose
export default ViewMultiContainerInvoice;
